/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  INVITE_USER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.adminPage.invite.user',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'INVITE_USER' },
      },
    },
    INVITE_USER: {
      invoke: {
        id: 'inviteUser',
        src: 'inviteUser',
        onDone: {
          target: 'INVITE_USER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'INVITE_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    INVITE_USER_SUCCESS: {
      on: {
        START: { target: 'INVITE_USER' },
      },
    },
    INVITE_USER_FAILED: {
      on: {
        START: { target: 'INVITE_USER' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
